import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/@/components/ui/tabs';
import { TAREFAS_CONFIG_DESIGN } from './TarefasConfig.design';
import WorkflowsTab from './WorkflowsTab';
import { actionListaWorkflows } from 'src/actions/tarefas/actionTarefasConfig';
import Iconify from 'src/components/Iconify';

export default function TarefasConfigComponent() {
  const { user } = useAuth();
  const [listaWorkflows, setListaWorkflows] = useState([]);

  async function buscarWorkflows() {
    try {
      const response = await actionListaWorkflows(`?cliente_id=${user.clienteId}`);
      setListaWorkflows(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    buscarWorkflows();
  }, []);

  return (
    <div className={TAREFAS_CONFIG_DESIGN.page.container}>
      {/* Header */}
      <div className={TAREFAS_CONFIG_DESIGN.page.header.container}>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-violet-100 flex items-center justify-center">
            <Iconify icon="mdi:clipboard-check-outline" width={28} className="text-violet-600" />
          </div>
          <div>
            <h1 className={TAREFAS_CONFIG_DESIGN.page.header.title}>Tarefas</h1>
            <p className={TAREFAS_CONFIG_DESIGN.page.header.subtitle}>
              Gerencie os workflows e estágios das suas tarefas.
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="workflows" className="w-full">
        <TabsList className={TAREFAS_CONFIG_DESIGN.tabs.list}>
          <TabsTrigger value="workflows" className={TAREFAS_CONFIG_DESIGN.tabs.trigger}>
            Workflows
          </TabsTrigger>
        </TabsList>

        <TabsContent value="workflows" className="mt-6">
          <WorkflowsTab
            listaWorkflows={listaWorkflows}
            onRefresh={buscarWorkflows}
            clienteId={user.clienteId}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
